module.exports = __webpack_public_path__ + "img/0d1b362.png";